<template>
  <form
    class="font-sans text-sm rounded w-full max-w-md mx-auto my-8 px-8 pt-6 pb-8"
  >
    <div class="text-center">
      <h1 class="my-4 font-medium">GET IN TOUCH</h1>
      <p class="leading-normal mb-4 max-w-sm m-auto">
        Fill out this form to receive your free analysis and consultation!
      </p>
    </div>

    <div class="text-center" v-if="errors.length">
      <b>Please correct the following error(s):</b>
      <ul>
        <li v-for="error in errors" :key="error">{{ error }}</li>
      </ul>
    </div>

    <div
      v-if="successComplete"
      class="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3"
      role="alert"
    >
      <p class="font-bold">Thank you {{ name }}!</p>
      <p class="text-sm">
        Someone will be in touch with you soon to discuss your project!.
      </p>
    </div>

    <div
      class="relative border rounded mb-4 shadow appearance-none label-floating"
    >
      <input
        class="w-full py-2 px-3 text-grey-darker leading-normal rounded"
        id="name"
        type="text"
        placeholder="Name"
        v-model="name"
      />
      <label
        class="absolute block text-grey-darker pin-t pin-l w-full px-3 py-2 leading-normal"
        for="name"
        >Name</label
      >
    </div>
    <div
      class="relative border rounded mb-4 shadow appearance-none label-floating"
    >
      <input
        class="w-full py-2 px-3 text-grey-darker leading-normal rounded"
        id="phone"
        type="phone"
        placeholder="Phone"
        v-model="phone"
      />
      <label
        class="absolute block text-grey-darker pin-t pin-l w-full px-3 py-2 leading-normal"
        for="phone"
        >Phone</label
      >
    </div>
    <div
      class="relative border rounded mb-4 shadow appearance-none label-floating"
    >
      <input
        class="w-full py-2 px-3 text-grey-darker leading-normal rounded"
        id="email"
        type="email"
        placeholder="Email"
        v-model="email"
      />
      <label
        class="absolute block text-grey-darker pin-t pin-l w-full px-3 py-2 leading-normal"
        for="email"
        >Email</label
      >
    </div>
    <div
      class="relative border rounded mb-4 shadow appearance-none label-floating"
    >
      <input
        class="w-full py-2 px-3 text-grey-darker leading-normal rounded"
        id="company"
        type="text"
        placeholder="Company"
        v-model="company"
      />
      <label
        class="absolute block text-grey-darker pin-t pin-l w-full px-3 py-2 leading-normal"
        for="company"
        >Company</label
      >
    </div>
    <div
      class="relative border rounded mb-4 shadow appearance-none label-floating"
    >
      <input
        class="w-full py-2 px-3 text-grey-darker leading-normal rounded"
        id="website"
        type="text"
        placeholder="Website"
        v-model="website"
      />
      <label
        class="absolute block text-grey-darker pin-t pin-l w-full px-3 py-2 leading-normal"
        for="website"
        >Website</label
      >
    </div>
    <div class="flex items-center justify-between">
      <button
        :class="submitting ? 'bg-grey' : 'bg-black'"
        class="hover:bg-grey text-white py-2 px-4"
        type="button"
        @click="checkForm"
      >
        Submit
      </button>
      <!-- <a
        class="inline-block align-baseline text-grey hover:text-grey-darker"
        href="#"
      >Forgot Password?</a>-->
    </div>
  </form>
</template>

<script>
import { setTimeout } from "timers";
export default {
  name: "contactform",
  data() {
    return {
      errors: [],
      name: "",
      email: "",
      company: "",
      phone: "",
      website: "",
      submitting: false,
      successComplete: false
    };
  },
  methods: {
    /**
     * Submit Form
     *
     * Submitting the form
     */
    submitForm() {
      console.log("submitting");
      this.submitting = true;

      const data = {
        email: this.email,
        name: this.name,
        company: this.company,
        website: this.website,
        phone: this.phone
      };

      this.email = "";

      this.successComplete = true;

      fetch("https://experiaweb.com/.netlify/functions/subscribe", {
        method: "POST",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify(data)
      })
        .then(e => e.json())
        .then(response => {
          // Show some indication that form was submitted.
          this.successComplete = true;

          return response;
        })
        .catch(e => {
          throw new Error(e);
        })
        .finally(() => {
          setTimeout(() => {
            this.successComplete = false;

            // Clear the form.
            this.email = "";
            this.name = "";
            this.company = "";
            this.website = "";
            this.phone = "";
          }, 5000);
        });
    },

    /**
     * CheckForm
     */
    checkForm(e) {
      this.errors = [];

      if (!this.name) {
        this.errors.push("Name is required ");
      }

      if (!this.email) {
        this.errors.push("Email is required ");
      }

      if (!this.phone) {
        this.errors.push("Phone is required ");
      }

      if (!this.errors.length) {
        this.submitForm();
      }

      e.preventDefault();
    }
    /**
     * Valid Email
     */
  }
};
</script>
